<template>
  <Dialog title="详情" v-model="dialogVisible" :padding="0" appendToBody :footer="false">
    <div class="con" v-loading="loading">
      <div class="item">
        <div class="title">{{ dict('userCarType', info.type || '') }}</div>
        <div class="flex mt-4">
          <div>{{ info.applyUserName }}提交</div>
          <div class="ml-4">{{ formatTime(info.applyTime) }}</div>
        </div>
      </div>
      <div class="min-h-[100px]" v-if="info.type === 1">
        <!-- 正常订单 -->
        <div v-if="info.orderType === 1">
          <div class="item mt-4">
            <!-- 申请单信息 -->
            <div class="title">详情</div>
            <div class="mt-4 label">行程信息</div>
            <div class="trip mt-4">
              <el-timeline>
                <el-timeline-item :type="getTripType(index)" hide-timestamp v-for="(item, index) in trip" :key="index">
                  <div>{{ item.name }}</div>
                </el-timeline-item>
              </el-timeline>
            </div>
            <div class="mt-4 label">预计出发时间</div>
            <div class="text">{{ formatTime(formData.startTime) }}</div>
            <div class="mt-4 label">预计结束时间</div>
            <div class="text">{{ formatTime(formData.endTime) }}</div>
            <div class="mt-4 label">用车事由</div>
            <div class="text">{{ formData.remark }}</div>
          </div>
          <!-- 流程 -->
          <div class="item mt-4">
            <div class="title">流程</div>
            <flow-nodes :flow="processInfo" v-if="processInfo.flow"></flow-nodes>
          </div>
        </div>
        <!-- 挪车订单 -->
        <div class="item mt-4" v-else-if="info.orderType === 2">
          <div class="title">详情</div>
          <div class="text-hui text-xs mt-2">{{ info.moveDescribe }}</div>
        </div>
      </div>
      <!-- 车辆轨迹 -->
      <div class="item mt-4">
        <div class="flex items-center justify-between">
          <div class="flex items-center">
            <div class="text-base text-[#333]">{{ info.lisence }}<span v-if="info.carTypeName">（{{ info.carTypeName
            }}）</span></div>
            <DictTag class="ml-2" name="carUseStatus" :value="info.useStatus"></DictTag>
          </div>
          <div class="flex items-baseline" v-if="info.useStatus === 2">
            <div class="flex items-baseline mr-[20px]"><span class="text-lg">{{ formatMoney(info.fee) }}</span>元</div>
            <div class="flex items-center cursor-pointer hover:opacity-70" @click="feeVisible = true">
              <div>费用详情</div>
              <i class="el-icon-arrow-right ml-[5px]"></i>
            </div>
          </div>
        </div>
        <!-- 地图 -->
        <div class="mt-4">
          <div ref="map" class="w-full h-[200px]"></div>
        </div>
        <div class="mt-4">
          <el-timeline>
            <el-timeline-item type="primary" hide-timestamp v-for="(item, index) in info.eventList || []" :key="index">
              <div>
                <div class="flex items-center">
                  <div>{{ dict('alarmType', item.alarmType || '') }}</div>
                  <div class="ml-2 text-hui">{{ formatTime(item.sysTime) }}</div>
                </div>
                <div class="mt-[5px] text-hui flex items-baseline">
                  <i class="el-icon-location-outline mr-[5px]"></i>
                  <div>{{ item.position }}</div>
                </div>
                <div v-if="item.alarmType === 4 && info.finishType === 2" class="mt-[10px] text-orange-500">
                  {{ dict('finishType', info.finishType) }}：
                  {{ info.finishUsername }}，
                  {{ formatTime(info.endTime) }}
                  <span v-if="info.finishRemark">，{{ info.finishRemark }}</span>
                </div>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
      <div class="item mt-4 card" v-if="info.type !== 1">
        <div class="card-label">取车验车单</div>
        <div class="card-right min-w-[100px] cursor-pointer hover:opacity-70" @click="getCheckVisible = true">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="item mt-4 card" v-if="info.type !== 1 && info.useStatus === 2">
        <div class="card-label">还车验车单</div>
        <div class="card-right min-w-[100px] cursor-pointer hover:opacity-70" @click="returnCheckVisible = true">
          <div class="mr-[5px]">{{ dict('checkOrderStatus', info.checkStatus || '') }}</div>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <GetCheck :modelValue.sync="getCheckVisible" :orderId="info.orderId"></GetCheck>
      <ReturnCheck :modelValue.sync="returnCheckVisible" :orderId="info.orderId"></ReturnCheck>
      <Fee :modelValue.sync="feeVisible" :orderId="info.orderId"></Fee>
    </div>
  </Dialog>
</template>
<script>
import Dialog from '@/components/Dialog';
import FlowNodes from './flowNodes.vue';
import { getOrderDetail } from '@/api/rental';
import AMapLoader from "@amap/amap-jsapi-loader";
import wgs84togcj02N from '@/utils/wgs';
import carStart from '@/assets/images/monitor/icon_qidian@2x.png';
import carEnd from '@/assets/images/monitor/icon_zhongdian@2x.png';
import carDriving from '@/assets/images/monitor/car_driving.png';
import GetCheck from './getCheck.vue';
import ReturnCheck from './returnCheck.vue';
import Fee from './fee.vue';

export default {
  components: { Dialog, FlowNodes, GetCheck, ReturnCheck, Fee },
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
  },
  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val;
        if (val) {
          this.initMap();
        }
      },
      immediate: true,
    },
    dialogVisible(val) {
      this.$emit('change', val);
    },
  },
  computed: {
    // 申请单信息
    processInfo() {
      return this.info.processInfo || {};
    },
    // 流程表单
    formData() {
      return this.processInfo.formData || {}
    },
    // 行程信息
    trip() {
      return this.formData.route || [];
    },
    gps() {
      return (this.gpsList || []).map(ele => ele.lnglat);
    },
  },
  data() {
    return {
      gpsList: [],
      feeVisible: false,
      returnCheckVisible: false,
      getCheckVisible: false,
      carStart,
      carEnd,
      carDriving,
      polyline: null,
      map: null,
      AMap: null,
      geocoder: null,
      loading: false,
      info: { type: 1 },
      dialogVisible: false,
    };
  },
  beforeDestroy() {
    if (this.map) {
      this.map.destroy();
    }
    this.AMap = null;
    this.map = null;
    this.geocoder = null;
    this.polyline = null;
  },
  methods: {
    // 地图
    initMap() {
      AMapLoader.load({
        key: this.amapKey,
        version: "2.0",
        plugins: ["AMap.Polyline", 'AMap.MoveAnimation', 'AMap.Geocoder']
      }).then(amap => {
        this.AMap = amap;
        const mapDom = this.$refs.map;
        this.map = new this.AMap.Map(mapDom, {
          zoom: 12,
        });
        this.geocoder = new this.AMap.Geocoder();
        this.doInfo();
      });
    },
    // 计算行程类型图标
    getTripType(idx) {
      const len = this.trip.length;
      let res = '';
      if (idx === 0) {
        res = 'primary';
      } else if (idx === len - 1) {
        res = 'warning';
      } else {
        res = 'info';
      }
      return res;
    },
    // 获取订单详情
    doInfo() {
      if (!this.orderId) return;
      this.loading = true;
      getOrderDetail(this.orderId).then(res => {
        this.info = res || {};
        // 告警点
        (this.info.eventList || []).forEach(item => {
          // const lnglat = wgs84togcj02N(item.longitude, item.latitude);
          const lnglat = [item.longitude, item.latitude];
          this.geocoder.getAddress(lnglat, (status, result) => {
            if (status === 'complete' && result.regeocode) {
              const res = result.regeocode.formattedAddress;
              this.$set(item, 'position', res);
            }
          });
        });
        this.setAlarmMarker();
        // 轨迹
        this.gpsList = (res.gpsList || []).map(ele => {
          const lnglat = wgs84togcj02N(ele.longitude, ele.latitude);
          return {
            ...ele,
            lnglat
          };
        });
        this.setPolyline();
        this.map.setFitView(null, true, [100, 100, 100, 100]);
      }).finally(() => {
        this.loading = false;
      })
    },
    setAlarmMarker() {
      this.map.clearMap();
      const list = this.info.eventList || [];
      list.forEach(ele => {
        if (!ele.longitude || !ele.latitude) return;
        const lnglat = wgs84togcj02N(ele.longitude, ele.latitude);
        if (+ele.alarmType === 1) {
          // 起始点
          const startIcon = new this.AMap.Icon({
            image: this.carStart,
            size: new this.AMap.Size(50, 50),
          });
          const startMarker = new this.AMap.Marker({
            position: lnglat,
            zIndex: 12,
            offset: new AMap.Pixel(-25, -25),
            // offset: new this.AMap.Pixel(-25, -25),
            icon: startIcon,
          });
          this.map.add(startMarker);
        } else if (+ele.alarmType === 4) {
          // 终点
          const endIcon = new AMap.Icon({
            image: this.carEnd,
            size: new AMap.Size(50, 50),
          });
          const endMarker = new AMap.Marker({
            position: lnglat,
            zIndex: 12,
            offset: new AMap.Pixel(-25, -25),
            icon: endIcon,
          });
          this.map.add(endMarker);
        } else {
          // 途径点
          const alarmIcon = new AMap.Icon({
            image: this.carDriving,
            size: new AMap.Size(50, 50),
          });
          const marker = new this.AMap.Marker({
            position: lnglat,
            zIndex: 12,
            offset: new this.AMap.Pixel(-25, -25),
            icon: alarmIcon,
          });
          this.map.add(marker);
        }
      });
    },
    setPolyline() {
      if (this.polyline) {
        this.map.remove(this.polyline);
        this.polyline = null;
      }
      const len = this.gps.length;
      if (!len) return;
      // 路径
      this.polyline = new this.AMap.Polyline({
        path: this.gps,
        //线颜色
        strokeColor: '#181F4D',
        //线透明度
        strokeOpacity: 1,
        //线宽
        strokeWeight: 5,
        //折线拐点的绘制样式
        lineJoin: 'round',
        //线样式
        strokeStyle: 'solid',
        //显示白色方向箭头
        showDir: false
      });
      this.map.add(this.polyline);
    }
  },
};
</script>
<style scoped lang="scss">
::v-deep .el-form-item__label {
  padding: 0;
}

.con {
  background: rgba(250, 250, 255, 1);
  padding: 20px;
  font-size: 13px;
}

.item {
  background: #fff;
  padding: 20px;
}

.title {
  font-size: 16px;
  color: #000;
  font-weight: 500;
}

.label {
  font-size: 13px;
  color: #999999;
}

.text {
  color: #393939;
  margin-top: 5px;
}

.trip {
  background: rgba(250, 250, 255, 1);
  padding: 15px;
  border-radius: 4px;
}

::v-deep .el-timeline {
  .el-timeline-item:nth-last-of-type(1) {
    padding: 0;
  }
}

::v-deep .el-timeline-item__wrapper {
  top: -2px;
}

.maptrip {
  padding: 10px;

  .line {
    border-left: 1px solid $theme;
    padding: 20px 10px;
    margin-left: 4px;
  }

  .dot {
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: $theme;
    display: flex;
  }

  .topdot {
    background: $theme;
  }

  .start {
    position: relative;

    .start-top {
      display: flex;
      align-items: center;
    }

    .startpoi {
      position: absolute;
      display: flex;
      align-items: center;
      top: 20px;
    }
  }
}

.card {
  padding: 20px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .card-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .card-label {
    font-size: 14px;
    font-weight: 500;
  }
}

:deep(.amap-icon) img {
  width: 100%;
  height: 100%;
}

:deep(.amap-logo) {
  display: none !important;
}

:deep(.amap-copyright) {
  display: none !important;
}
</style>
  
  